import $ from 'jquery';
import { searchQuickOrderParts } from '../search/quick-order-meilisearch.js';
import {
    getItemInventory,
    clearOrderRowInventory,
} from '../ordering/inventory.js';
import {
    validateOrderRows,
    renameOrderRows,
} from '../ordering/validation.js';
import { syncRowWarehouseIdentifiers } from '../ordering/row-identity.js';
import { spinnerHtml, escapeHtml } from '../core/utilities.js';

var $suggestionMount = null;
var activePartInputEl = null;
var searchSeq = 0;
var hideTimer = null;
var KEY_DOWN = 40;
var KEY_UP = 38;
var KEY_ENTER = 13;
var KEY_ESC = 27;

function ensureSuggestionMount() {
    if ($suggestionMount && $suggestionMount.length) {
        return $suggestionMount;
    }
    $suggestionMount = $(
        '<div id="quick-order-suggestions-mount" class="quick-order-suggestions shadow" role="listbox" aria-label="Part suggestions" />'
    );
    $('body').append($suggestionMount);
    return $suggestionMount;
}

function hideSuggestions() {
    if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
    }
    if ($suggestionMount) {
        $suggestionMount.empty().hide();
    }
    activePartInputEl = null;
}

function scheduleHide() {
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
        hideSuggestions();
    }, 200);
}

function cancelScheduledHide() {
    if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
    }
}

function positionSuggestions($input) {
    var el = $input[0];
    if (!el) return;
    var r = el.getBoundingClientRect();
    var $m = ensureSuggestionMount();
    var w = Math.max(320, r.width);
    $m.css({
        position: 'fixed',
        left: Math.min(r.left, window.innerWidth - w - 8) + 'px',
        top: r.bottom + 4 + 'px',
        width: w + 'px',
        zIndex: 1080,
        display: 'block',
    });
}

function focusNextRowPartInput($row) {
    var $next = $row
        .nextAll('tr')
        .filter(function () {
            // Must be empty — landing in a committed row appends to its part number and corrupts it.
            var $part = $(this).find('.multi-order-part-number');
            return $part.length > 0 && ($part.val() || '').trim() === '';
        })
        .first();
    var el = $next.find('.multi-order-part-number')[0];
    if (!el) return;
    el.focus();
    if (typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ block: 'nearest' });
    }
}

function applyPartSelection($table, $row, brandCode, partRaw, options) {
    var $brand = $row.find('.multi-order-brand');
    var $part = $row.find('.multi-order-part-number');
    var $gtin = $row.find('.multi-order-gtin');
    var gtin = $gtin.val() != undefined ? $gtin.val().trim() : '';

    if ($row.hasClass('default-row')) {
        var $clone = $table.find('.default-row').clone();
        $clone.find('.multi-order-part-number').val('');
        $clone.find('optgroup, .hr').remove();
        $clone.appendTo($table.find('tbody'));
        $row.removeClass('default-row');
        $row.find('.multi-order-quantity').prop('disabled', false);
        renameOrderRows($table);
    }

    hideSuggestions();
    $brand.find('option[value="' + brandCode + '"]')
        .not('.match')
        .prop('selected', true);
    $part.val(partRaw);
    // The two assignments above re-identify the row without firing input or change, so the
    // delegated synchroniser in ordering/index.js never sees this edit - and on a row cloned
    // from a past order, data-whlc / data-whsn still describe the part it arrived as.
    // getItemInventory() falls back to them for either identifier left out below, so it has
    // to happen here rather than at the next real event. #700
    syncRowWarehouseIdentifiers($row);
    getItemInventory($row, {
        aaia: brandCode,
        partnumber: partRaw,
        gtin: gtin,
    });
    validateOrderRows($table);

    // Last, so the cloned blank row exists and has been renamed before focus lands in it.
    if (options && options.advanceFocus) {
        focusNextRowPartInput($row);
    }
}

function renderSuggestionRows(rows, $input, $row, $table) {
    var $m = ensureSuggestionMount();
    $m.empty();
    rows.forEach(function (row, idx) {
        var label = row.BrandLabel ? ' — ' + row.BrandLabel : '';
        var $btn = $(
            '<button type="button" class="quick-order-suggestions__item dropdown-item text-start" role="option" />'
        );
        $btn.attr('id', 'quick-order-suggestion-' + idx);
        $btn.data('qoBrand', row.AAIABrandCode);
        $btn.data('qoPart', row.PartNumber);
        // String() coerces the type but does not neutralise markup: part numbers and brand
        // labels come from the Meilisearch hit or the PHP autocomplete fallback verbatim, and
        // this is a .html() sink. The navbar autocomplete has always escaped the same fields.
        $btn.html(
            '<span class="fw-semibold">' +
                escapeHtml(row.PartNumber) +
                '</span><span class="text-muted">' +
                escapeHtml(label) +
                '</span>'
        );
        $m.append($btn);
    });
    $m.attr('aria-activedescendant', '');
    positionSuggestions($input);
    $m.off('mousedown.quickOrder').on('mousedown.quickOrder', function (e) {
        e.preventDefault();
    });
    $m.off('click.quickOrder', '.quick-order-suggestions__item')
        .on(
            'click.quickOrder',
            '.quick-order-suggestions__item',
            function (e) {
                e.preventDefault();
                var $b = $(this);
                applyPartSelection(
                    $table,
                    $row,
                    $b.data('qoBrand'),
                    $b.data('qoPart')
                );
            }
        );
}

function runPartSearch($input, $row, $table) {
    var q = $input.val().trim();
    var my = ++searchSeq;
    activePartInputEl = $input[0];

    if (q.length < 2) {
        hideSuggestions();
        return;
    }

    var $m = ensureSuggestionMount();
    $m.html(
        '<div class="p-3 text-muted small">' +
            spinnerHtml('Searching…') +
            '</div>'
    );
    positionSuggestions($input);
    $m.show();

    var brandFilter = ($row.find('.multi-order-brand').val() || '').trim();
    searchQuickOrderParts(q, { brandAaia: brandFilter }).then(function (rows) {
        // isConnected: the search is in flight for as long as the network takes, and the row
        // it belongs to can be gone by the time it answers - the modal closed, or the browse
        // shell replaced the card the modal was opened from. searchSeq only catches a NEWER
        // search superseding this one and activePartInputEl only catches focus moving to a
        // different row, so neither notices a detached node, and positionSuggestions() then
        // measures a node with no layout and reads window off a document that has gone.
        if (
            my !== searchSeq ||
            activePartInputEl !== $input[0] ||
            !$input[0].isConnected
        ) {
            return;
        }
        if (!rows.length) {
            $m.html(
                '<div class="p-3 text-muted small">No matches — try another part #</div>'
            );
            positionSuggestions($input);
            return;
        }
        renderSuggestionRows(rows, $input, $row, $table);
    });
}

function moveActiveSuggestion(delta) {
    var $m = ensureSuggestionMount();
    if (!$m.is(':visible')) return;
    var $items = $m.find('.quick-order-suggestions__item');
    if (!$items.length) return;
    var $cur = $items.filter('.active');
    var idx = $cur.length ? $items.index($cur) : -1;
    $items.removeClass('active');
    var next = idx + delta;
    if (next < 0) next = $items.length - 1;
    if (next >= $items.length) next = 0;
    var $n = $items.eq(next);
    $n.addClass('active');
    $m.attr('aria-activedescendant', $n.attr('id') || '');
}

function activateHighlightedSuggestion($input, $row, $table, options) {
    var $m = ensureSuggestionMount();
    var $h = $m.find('.quick-order-suggestions__item.active');
    if (!$h.length) {
        $h = $m.find('.quick-order-suggestions__item').first();
    }
    if ($h.length) {
        applyPartSelection(
            $table,
            $row,
            $h.data('qoBrand'),
            $h.data('qoPart'),
            options
        );
    }
}

export function initQuickOrderModal() {
    var $modal = $('#orderModal');
    if (!$modal.length) {
        return;
    }

    var $form = $modal.find('form');

    $(window).on('resize.quickOrder scroll.quickOrder', function () {
        if (
            $suggestionMount &&
            $suggestionMount.is(':visible') &&
            activePartInputEl
        ) {
            positionSuggestions($(activePartInputEl));
        }
    });

    $modal.on('hidden.bs.modal.quickOrder', function () {
        hideSuggestions();
        searchSeq++;
        // Rows survive the close, so their stock/cost would be shown again on the
        // next open as if they had just been checked. Drop the derived display and
        // disable ordering until the reopen refresh answers; the part number, brand
        // and quantity the user typed stay put.
        clearOrderRowInventory($modal.find('.multi-order-table'));
    });

    $modal.on('shown.bs.modal.quickOrder', function () {
        hideSuggestions();
    });

    $modal.on(
        'focusin.quickOrder',
        '.multi-order-part-number',
        function () {
            activePartInputEl = this;
        }
    );

    $modal.on(
        'input.quickOrder',
        '.multi-order-part-number',
        function () {
            var $input = $(this);
            var $row = $input.closest('tr');
            var $table = $row.closest('.multi-order-table');
            runPartSearch($input, $row, $table);
            var q = $input.val().trim();
            if (!q.length) {
                $row.find('.multi-order-brand').find('optgroup, .hr').remove();
            }
        }
    );

    $modal.on(
        'keydown.quickOrder',
        '.multi-order-part-number',
        function (e) {
            var $m = ensureSuggestionMount();
            if (!$m.is(':visible') || !$m.find('.quick-order-suggestions__item').length) {
                return;
            }
            if (e.keyCode === KEY_DOWN) {
                e.preventDefault();
                moveActiveSuggestion(1);
            } else if (e.keyCode === KEY_UP) {
                e.preventDefault();
                moveActiveSuggestion(-1);
            } else if (e.keyCode === KEY_ENTER) {
                var $input = $(this);
                var $row = $input.closest('tr');
                var $table = $row.closest('.multi-order-table');
                e.preventDefault();
                activateHighlightedSuggestion($input, $row, $table, {
                    advanceFocus: true,
                });
            } else if (e.keyCode === KEY_ESC) {
                e.preventDefault();
                hideSuggestions();
            }
        }
    );

    $modal.on('blur.quickOrder', '.multi-order-part-number', function () {
        scheduleHide();
    });

    $modal.on('focus.quickOrder', '.multi-order-part-number', function () {
        cancelScheduledHide();
    });

    $(document).on('click.quickOrder', function (e) {
        if (!$suggestionMount || !$suggestionMount.is(':visible')) return;
        var t = e.target;
        if ($suggestionMount[0].contains(t)) return;
        if ($(t).closest('.multi-order-part-number').length) return;
        if ($(t).closest('#orderModal').length) hideSuggestions();
    });

    $modal.on(
        'paste input change keyup.quickOrderBrand',
        '.multi-order-brand',
        function (e) {
            var $self = $(this);
            var $table = $self.closest('.multi-order-table');
            var $row = $self.closest('tr');
            var $brand = $row.find('.multi-order-brand');
            var $partNumber = $row.find('.multi-order-part-number');
            var $gtin = $row.find('.multi-order-gtin');
            var brand = $brand.val() != null ? $brand.val().trim() : '';
            var partNumber = $partNumber.val().trim();
            var gtin = $gtin.val() != undefined ? $gtin.val().trim() : '';

            if ($row.hasClass('default-row') && brand.length > 0) {
                var $clone = $table.find('.default-row').clone();
                $clone
                    .find('.multi-order-part-number')
                    .val('');
                $clone.find('optgroup, .hr').remove();
                $clone.appendTo($table.find('tbody'));
                $row.removeClass('default-row');
                $row.find('.multi-order-quantity').prop('disabled', false);
                renameOrderRows($table);
            }

            if (brand.length > 0) {
                var $defaultRow = $table.find('.default-row');
                $defaultRow.find('optgroup, .hr').remove();
                $defaultRow.find('.multi-order-part-number').val('');
                $brand.attr(
                    'title',
                    $brand.find('option[value="' + brand + '"]').text()
                );
                if (partNumber.length > 0) {
                    getItemInventory($row, {
                        aaia: brand,
                        partnumber: partNumber,
                        gtin: gtin,
                    });
                }
            }

            validateOrderRows($table);
            if (brand.length < 1 && partNumber.length > 0) {
                $modal.find('form .btn-add-to-order').prop('disabled', true);
            }
        }
    );

    $modal.on(
        'change.quickOrderQty',
        '.multi-order-quantity',
        function () {
            validateOrderRows(
                $(this).closest('.multi-order-table')
            );
        }
    );
}
